import { Injectable } from '@angular/core';
import { LocaleService } from 'src/app/_services/locale.service';
import { BehaviorSubject, Observable } from 'rxjs';

export type CollectiveLoadState = 'loading' | 'loaded' | 'error';

@Injectable({
  providedIn: 'root'
})
export class CollectiveDataProvider {

  public hidrated: boolean = false;
  private logo = null;
  private logosm = null;
  private publicBackground = null;
  private bannerBackground = null;
  private serviceEmail = null;
  private serviceTelephone = null;
  private emergencyTelephone = null;
  private genderViolenceTelephone = null;


  // private registeringAllowed: true;
  // private socioSanitaryProfileRequired: false;
  // private allowAnonymousUser: false;
  // private allowCreateUserByRegisterToken: true;
  // private allowCreateUserByErpIdentifier: false;
  private securityStrategy: string = 'login_username.strategy';
  private trackActivity: boolean = false;
  // private sendCreatedUserEmail: true;
  // private allowCreateUserByInternalService: true;
  // private allowCreateUserByExternalService: false;
  // private apiKey: string ;
  // private features: any;
  // private loginMessageStatus: false;
  // private registerMessageStatus: true;
  // private recoveryMessageStatus: false;
  // private registerFormMessageStatus: true;
  // private registerFormRecoveryMessageStatus: false;
  // private logoProvider: string;
  // private serviceChat: string;
  // private videoCallsLink: string;
  // private complaintsChannel: string;
  // private veterinaryVideoCallsUrl: string;
  // private veterinaryChat: string;
  // private testamentisHereditary: string;
  // private testamentisLiving: string;
  // private id: number;
  // private name: string;
  // private active: number;
  // private color: string;
  
  private dataSource = new BehaviorSubject({});
  private loadStateSource = new BehaviorSubject<CollectiveLoadState>('loading');

  constructor(
    private localeService: LocaleService
  ) { }

  bindData(data) {
    this.logo = data.logo;
    this.logosm = data.logosm;
    this.publicBackground = data.publicBackground;
    this.bannerBackground = data.bannerBackground;
    this.serviceEmail = data.serviceEmail;
    this.serviceTelephone = data.serviceTelephone;
    this.emergencyTelephone = data.emergencyTelephone;
    this.genderViolenceTelephone = data.genderViolenceTelephone;


    this.securityStrategy = data.securityStrategy;
    this.trackActivity = data.trackActivity;
    // TODO: meter el resto de atributos

    this.dataSource.next(data);
    this.hidrated = true;
    this.loadStateSource.next('loaded');
  }

  bindError() {
    this.hidrated = false;
    this.loadStateSource.next('error');
  }

  setLoading() {
    this.hidrated = false;
    this.loadStateSource.next('loading');
  }

  getData(): Observable<any> {
    return this.dataSource.asObservable();
  }

  getLoadState(): Observable<CollectiveLoadState> {
    return this.loadStateSource.asObservable();
  }

  getPublicBackground() {
    return this.publicBackground;
  }

  getBannerBackground() {
    return this.bannerBackground;
  }

  getLogo() {
    return this.logo;
  }

  getLogosm() {
    return this.logosm;
  }

  getServiceEmail() {
    return this.serviceEmail;
  }

  getServiceTelephone() {
    return this.serviceTelephone;
  }

  getEmergencyTelephone() {
    return this.emergencyTelephone;
  }
  getGenderViolenceTelephone() {
    return this.genderViolenceTelephone;
  }

  getSecurityStrategy() {
    return this.securityStrategy;
  }

  /**
   * Solo se registra actividad si el colectivo lo tiene activado explícitamente.
   * Mientras no haya llegado la config del colectivo el valor es false, así que
   * los eventos que se disparen antes de la hidratación se descartan.
   */
  getTrackActivity(): boolean {
    return this.trackActivity === true;
  }
}
